import React, { useEffect, useState } from 'react';
import { Button, Tooltip, IconButton } from '@mui/material';
import { useHistory } from 'react-router-dom';
import MyButton from '../../../utils/MyButton';
import { FaArrowCircleLeft, FaFilePdf, FaEyeSlash, FaPaperclip } from "react-icons/fa";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getCliente} from '../../../redux/actions/dataactions';
import { getActivo, getMtoPrevActivo } from '../../../redux/actions/mobiliarioactions';


import { PDFViewer } from '@react-pdf/renderer';
import './ReporteMtoPDFActivo.css';
import ReporteMtoDocuPDFActivo from './ReporteMtoDocuPDFActivo';
import ReporteMtoDocuPDFV2Activo from './ReporteMtoDocuPDFV2Activo';

const ReporteMtoPDFActivo = ({ getActivo, getCliente, getMtoPrevActivo, data, dataMob, match }) => {
  const [verPDF, setVerPDF] = useState(false);
  const history = useHistory();

  const { cliente, loading } = data;
  const {mobiliario,mtomobiliario,loadingdata}=dataMob;

  useEffect(() => {
    getMtoPrevActivo(match.params.mtoid);
    getActivo(match.params.mobiliarioId);
    getCliente(match.params.clienteId);
  }, [getMtoPrevActivo, getActivo, getCliente, match.params.mtoid, match.params.mobiliarioId, match.params.clienteId]);

  const handleOpenPDF = () => {
    setVerPDF(!verPDF);
  };

  const goBack = () => {
    history.goBack();
  };

  const renderContent = () => {
    if (!cliente?.plantillaType) {
      return (
        <div className="mto-error-message">
          <p>Para ver las plantillas, primero debe configurar el tipo de plantilla en la lista de clientes</p>
        </div>
      );
    }

    if (mobiliario && cliente && verPDF) {
      if (mtomobiliario?.version === 2) {
        return (
          <PDFViewer style={{ width: "100%", height: "90vh" }}>
            <ReporteMtoDocuPDFV2Activo
              equipo={mobiliario} 
              cliente={cliente} 
              mtopreventivo={mtomobiliario} 
            />
          </PDFViewer>
        );
      }

      return (
        <PDFViewer style={{ width: "100%", height: "90vh" }}>
          <ReporteMtoDocuPDFActivo
            equipo={mobiliario} 
            cliente={cliente} 
            mtopreventivo={mtomobiliario} 
          />
        </PDFViewer>
      );
    }

    return null;
  };

  return (
    <div className="mto-pdf-wrapper">
      <div className="mto-pdf-header">
        <div className="mto-pdf-back-btn">
          <MyButton tip="Volver" onClick={goBack}>
            <FaArrowCircleLeft className="mto-pdf-back-icon" />
          </MyButton>
        </div>
        {cliente?.plantillaType && (
          <Tooltip title={verPDF ? "Ocultar PDF" : "Ver PDF"}>
            <IconButton
              color="#03178C"
              onClick={handleOpenPDF}
              aria-label={verPDF ? "Ocultar PDF" : "Ver PDF"}
              size="large"
            >
              {verPDF ? <FaEyeSlash color='#03178C'/> : <FaFilePdf color='#03178C' />}
            </IconButton>
          </Tooltip>
        )}

        {mtomobiliario?.archivoPDF && (
          <Tooltip title="Abrir archivo adjunto">
            <IconButton
              onClick={() => window.open(mtomobiliario.archivoPDF, "_blank")}
              aria-label="Abrir archivo adjunto"
              size="large"
            >
              <FaPaperclip color='#03178C' />
            </IconButton>
          </Tooltip>
        )}
      </div>
      <div className="mto-pdf-content">
        {renderContent()}
      </div>
    </div>
  );
}

ReporteMtoPDFActivo.propTypes = {
  getActivo: PropTypes.func.isRequired,
  getCliente: PropTypes.func.isRequired,
  getMtoPrevActivo: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  dataMob:PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  data: state.data,
  dataMob:state.dataMob
})

export default connect(mapStateToProps, { getActivo, getCliente, getMtoPrevActivo })(ReporteMtoPDFActivo);